import { named, optional, withDependencies } from '@wix/thunderbolt-ioc'
import type { Experiments } from '@wix/thunderbolt-symbols'
import {
	BrowserWindow,
	BrowserWindowSymbol,
	ExperimentsSymbol,
	FeatureExportsSymbol,
	ICyclicTabbing,
	ServicesManagerSymbol,
} from '@wix/thunderbolt-symbols'
import { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import { name } from './symbols'
import { createCyclicTabbing } from '@wix/cyclic-tabbing'
import type { ServicesManager } from '@wix/services-manager/types'
import { CyclicTabbingDefinition } from '@wix/viewer-service-cyclic-tabbing/definition'

export const CyclicTabbing = withDependencies(
	[BrowserWindowSymbol, named(FeatureExportsSymbol, name), ExperimentsSymbol, optional(ServicesManagerSymbol)],
	(
		browserWindow: BrowserWindow,
		cyclicTabbingExports: IFeatureExportsStore<typeof name>,
		experiments: Experiments,
		servicesManager?: ServicesManager
	): ICyclicTabbing => {
		let enableCyclicTabbing: ICyclicTabbing['enableCyclicTabbing']
		let disableCyclicTabbing: ICyclicTabbing['disableCyclicTabbing']
		if (experiments['specs.thunderbolt.servicesInfra'] && servicesManager?.hasService(CyclicTabbingDefinition)) {
			const cyclicTabbingService = servicesManager?.getService(CyclicTabbingDefinition)
			if (!cyclicTabbingService) {
				throw new Error('CyclicTabbingService is not registered')
			}
			;({ enableCyclicTabbing, disableCyclicTabbing } = cyclicTabbingService)
		} else {
			;({ enableCyclicTabbing, disableCyclicTabbing } = createCyclicTabbing({
				browserWindow: browserWindow as Window,
				screenReaderFocus: !!experiments['specs.thunderbolt.screen_reader_focus'],
			}))
		}

		return {
			enableCyclicTabbing,
			disableCyclicTabbing,
			appWillMount: () => {
				cyclicTabbingExports.export({
					enableCyclicTabbing,
					disableCyclicTabbing,
				})
			},
		}
	}
)
